/*
  パスワード強度チェッカー

  = javascript_pack_tag 'password-strength-checker'

  = f.password_field :password, class: 'form-control',
    data: { password_strength_check: api_password_strength_url },
    placeholder: User.human_attribute_name(:password)
*/

document.addEventListener('DOMContentLoaded', function () {
  const passwordInputs = document.querySelectorAll('[data-password-strength-check]');

  passwordInputs.forEach(passwordInput => {
    // 新しいdiv要素を作成
    const wrapper = document.createElement('div');
    wrapper.style.position = 'relative';
    wrapper.style.width = '100%';

    // 新しいspan要素を作成
    const passwordStrengthDisplay = document.createElement('span');
    passwordStrengthDisplay.classList.add('password-strength');

    // スタイルを設定
    passwordStrengthDisplay.style.position = 'absolute';
    passwordStrengthDisplay.style.right = '10px';
    passwordStrengthDisplay.style.top = '50%';
    passwordStrengthDisplay.style.transform = 'translateY(-50%)';
    passwordStrengthDisplay.style.maxWidth = 'calc(100% - 20px)';
    passwordStrengthDisplay.style.overflow = 'hidden';
    passwordStrengthDisplay.style.textOverflow = 'ellipsis';

    // パスワード入力欄をwrapperに移動
    passwordInput.parentNode.insertBefore(wrapper, passwordInput);
    wrapper.appendChild(passwordInput);

    // パスワード入力欄の後ろに追加
    wrapper.appendChild(passwordStrengthDisplay);

    let timeoutId;
    passwordInput.addEventListener('input', function () {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const password = this.value;
        const endpoint = this.dataset.passwordStrengthCheck;
        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ password: password })
        })
          .then((response) => response.json())
          .then((data) => {
            // パスワードの強度を表示
            passwordStrengthDisplay.textContent = data.strength;

            // スコアに応じて文字色を変更
            if (data.score <= 1) {
              passwordStrengthDisplay.style.color = 'red';
            } else if (data.score <= 2) {
              passwordStrengthDisplay.style.color = 'orange';
            } else {
              passwordStrengthDisplay.style.color = 'green';
            }
          });
      }, 500);
    });
  });
});
